"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = exports.ListUtils = void 0;
var helpers_1 = require("../../../helpers");
var main_1 = require("../../../main");
var list_style_1 = require("./list.style");
exports.ListUtils = {
    ListRenderer: function (__deps__, ListItemComponent, list, showAddAndDeleteBtn, showSortingOption, showOptionsButton, childrenProps) {
        return list.map(function (listItem, index) {
            var _a, _b;
            var props = __assign(__assign(__assign({}, childrenProps), listItem), { index: index });
            return __deps__.createElement(__deps__.Fragment, {
                key: "".concat(listItem.id, "-fragment-container"),
            }, 
            /*__deps__.createElement(
              "style",
              {
                key: `${listItem.id}-style-container`,
                dangerouslySetInnerHTML: { __html: `${childrenProps.isEditMode ? ".list-item-container:has(.hidden){display: none !important;}" : ""}` }
              }
                PEZZO COMMENTATO PER VIA DEL NUOVO VISORE EMPTY (CSS ONLY, L'ELEMNTO STYLE VENIVA CONSIDERATO NEL CONTEGGIO DEL CAROSELLO E QUINDI COME SLIDE IN PIÙ)
            ),*/
            __deps__.createElement("div", {
                key: "".concat(listItem.id, "-container"),
                id: "".concat(listItem.id, "-slide"),
                className: "list-item-container",
                style: showSortingOption && childrenProps.isEditMode
                    ? { display: "flex", flexDirection: "column", gap: "2px" }
                    : {},
            }, childrenProps.isEditMode &&
                showSortingOption &&
                exports.ListUtils.OrdinamentoOptionRender(__deps__, childrenProps.__host__, showSortingOption, childrenProps.isEditMode, listItem.id, listItem.name, listItem.description), __deps__.createElement(ListItemComponent, __assign(__assign({}, props), { key: listItem.id })), __deps__.createElement("div", {
                className: "list-item-settings-icon-container",
            }, 
            // __deps__.createElement(Remote, {
            //   ...props,
            //   __deps__,
            //   id: generateID(listItem.id, `visualization-settings`),
            //   __mfeName__: MFE_NAMES.tpdVisualizationSettings,
            // }),
            __deps__.createElement("div", {}), exports.ListUtils.SettingsIconRenderer(__deps__, listItem.id, listItem.name, childrenProps.isEditMode, showAddAndDeleteBtn, showOptionsButton, (_a = childrenProps.__host__.placement) === null || _a === void 0 ? void 0 : _a.actionContent), exports.ListUtils.DeleteIconRenderer(__deps__, listItem.id, listItem.name, childrenProps.isEditMode, showAddAndDeleteBtn, (_b = childrenProps.__host__.placement) === null || _b === void 0 ? void 0 : _b.actionContent))));
        });
    },
    OrdinamentoOptionRender: function (__deps__, __host__, showSortingOption, isEditMode, elementId, name, description) {
        var _a = __deps__.useState(description), sortingValue = _a[0], setSortingValue = _a[1];
        var _b = __deps__.useState(false), isOpaque = _b[0], setIsOpaque = _b[1];
        return (isEditMode &&
            showSortingOption &&
            __deps__.createElement("div", {
                className: "ordinamento",
                style: (0, list_style_1.SortingOptioDivStyle)(isOpaque),
            }, __deps__.createElement("span", {
                style: list_style_1.SortingOptionSpanStyle,
            }, "Ordinamento: "), __deps__.createElement("div", {
                className: "portal_tooltips_icon",
                title: "Indica la possibilità di ordinare gli elementi",
            }, "?"), __deps__.createElement("input", {
                type: "text",
                style: list_style_1.SortingOptionInputStyle,
                defaultValue: sortingValue,
                onBlur: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                setSortingValue(e.target.value);
                                if (!(e.target.value !== sortingValue)) return [3 /*break*/, 2];
                                setIsOpaque(true);
                                return [4 /*yield*/, main_1.Providers.CMSProxyService.getInstance()
                                        .saveDescription(elementId, __host__.placement.projectId, __host__.placement.projectName, e.target.value, name)
                                        .then(function () {
                                        setIsOpaque(false);
                                    })
                                        .catch(function () {
                                        alert("non è stato possibile salvare l'ordinamento ");
                                        setIsOpaque(false);
                                    })];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); },
            })));
    },
    SettingsIconRenderer: function (__deps__, elementId, elementName, isEditMode, showAddAndDeleteBtn, showOptionsButton, actionContent) {
        return isEditMode &&
            showOptionsButton &&
            __deps__.createElement("div", {
                onClick: function () {
                    helpers_1.EditContentHelper.triggerEditContent(actionContent, helpers_1.EditMode.read, elementId, elementName);
                },
                className: "edit-mode-settings-icon",
            });
    },
    DeleteIconRenderer: function (__deps__, elementId, elementName, isEditMode, showAddAndDeleteBtn, actionContent) {
        return isEditMode &&
            showAddAndDeleteBtn &&
            __deps__.createElement("div", {
                onClick: function () {
                    helpers_1.EditContentHelper.triggerEditContent(actionContent, helpers_1.EditMode.delete, elementId, elementName);
                },
                className: "edit-mode-delete-icon",
            });
    },
    BoilerplateRenderer: function (__deps__, elementId, elementName, isEditMode, showAddAndDeleteBtn, showSortingOption, actionContent) {
        return isEditMode &&
            showAddAndDeleteBtn &&
            __deps__.createElement(__deps__.Fragment, {}, __deps__.createElement("div", {
                onClick: function () {
                    helpers_1.EditContentHelper.triggerEditContent(actionContent, helpers_1.EditMode.create, elementId, elementName);
                },
                className: "boilerplate-container list-item-container",
                style: { marginTop: showSortingOption ? "68px" : "0" },
            }, __deps__.createElement("div", {
                className: "boilerplate-plus-icon",
            }), __deps__.createElement("div", {
                className: "boilerplate-text",
            }, "AGGIUNGI ITEM")));
    },
};
function List(_a) {
    var _b;
    var __deps__ = _a.__deps__, ListItemComponent = _a.ListItemComponent, _c = _a.list, list = _c === void 0 ? [] : _c, _d = _a.showAddAndDeleteBtn, showAddAndDeleteBtn = _d === void 0 ? true : _d, _e = _a.showSortingOption, showSortingOption = _e === void 0 ? false : _e, _f = _a.showOptionsButton, showOptionsButton = _f === void 0 ? true : _f, childrenProps = __rest(_a, ["__deps__", "ListItemComponent", "list", "showAddAndDeleteBtn", "showSortingOption", "showOptionsButton"]);
    return __spreadArray(__spreadArray([], exports.ListUtils.ListRenderer(__deps__, ListItemComponent, list, showAddAndDeleteBtn, showSortingOption, showOptionsButton, childrenProps), true), [
        exports.ListUtils.BoilerplateRenderer(__deps__, undefined, list && list.length ? list[0].name : "", childrenProps.isEditMode, showAddAndDeleteBtn, showSortingOption, (_b = childrenProps.__host__.placement) === null || _b === void 0 ? void 0 : _b.actionContent),
    ], false);
}
exports.List = List;
